import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearContent } from "../../store/actions/detailsDocument/preview";
import { getFolders, updateDocsFolder } from "../../store/actions/folders";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getDetailDocument,
  setDocumentVisibility
} from "../../store/actions/detailsDocument/index";
import {
  getDocumentsWithSearch,
  updateReadCustomer
} from "../../store/actions/documentsWithSearch/index";
import {
  resetDownloadDocument
} from "../../store/actions/download/index";
import { getIconByType } from "../../libs/documentsUtils";
import { Modal, Button } from "@ts-digital/vrc";
import { Spin } from "antd";
import Page from "../../components/general/page";
import Table from "../../components/vapor/table";
import ArrowsCursor from "../../components/documentDetails/arrowsCursor";
import DeleteButton from "../../components/documentDetails/deleteButton";
import Details from "../../components/documentDetails/details";
import Note from "../../components/documentDetails/note";
import Preview from "../../components/documentDetails/preview/index";
import TabDetails from "../../components/documentDetails/tabDetails";
import DownloadProgress from "../../components/downloadProgress/index";
import { categoryToDesc } from "../../constants/folders";
import { FormattedMessage, useIntl } from "react-intl";
import { startDownloadData } from "../../libs/utils";
import "./style.css";
  
const DocumentDetail = ({pageRef, documentTypes}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const documentsWithSearch = useSelector(state => state.documentsWithSearch);
  const detailsDocument = useSelector(state => state.detailsDocument);
  const download = useSelector(state => state.download);
  const company = useSelector(state=> state.company);
  const main = useSelector(state => state.main);
  const folders = useSelector(state => state.folders.folders);
  const servicesAgyo = useSelector(state => state.servicesAgyo);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentTab, setCurrentTab] = useState(1);
  const [idByUrl, setIdByUrl] = useState(location.pathname.split("dettaglio-documento/")[1]);
  const [modalFoldervisible, setModalFoldervisible] = useState(false);
  const [foldersSelected, setFoldersSelected] = useState([]);        

  const myType = main.myType;
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;  
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;

  const intl = useIntl();

  useEffect(() => {
    dispatch(clearContent());
    /* provenendo da una lista molto lunga della documenti devo ripuntare al top della pagina */
    window.scrollTo(0, 0);

    let indexDocsList =
      documentsWithSearch.results.list &&
      documentsWithSearch.results.list.findIndex(el => {
        return el.documentId === idByUrl;
      });
    setCurrentIndex(indexDocsList ? indexDocsList : 0);    

    dispatch(getFolders());
    if (auth && idByUrl) {
      dispatch(getDetailDocument(idByUrl));
    }
  }, [idByUrl]);
  
  useEffect(() => {
    if (!documentsWithSearch.results.list) return undefined;
    const indexDocsList = documentsWithSearch.results.list.findIndex(el => {
      return el.documentId === idByUrl;
    });

    setCurrentIndex(indexDocsList ? indexDocsList : 0);
    
    return (() => {
      // TODO: Capire se qui si può rimuovere il clearContent per ripristinare la visualizzazione di anteprima documento anche dopo apertura popup gestisci doc collegati
      // dispatch(clearContent());      
    });
  }, [idByUrl, documentsWithSearch.results.list]);
  
  useEffect(() => {

    if (detailsDocument.info.status.error && 
        detailsDocument.info.errorCode && 
        detailsDocument.info.errorCode === 400) {
      navigate("/documenti");
    }
  
    /** Se sono all'ultimo dovumento del pacchetto di ingresso e links è ancora valorizzato, allora chiedo il prossimo slot */
    if (
      !detailsDocument.isDocRemoved.success &&
        documentsWithSearch.results.list &&
        currentIndex === documentsWithSearch.results.list.length - 1 &&
        !documentsWithSearch.isGettingDocumentsWithSearch &&
        documentsWithSearch.links !== null
    ) {
      dispatch(getDocumentsWithSearch(
        documentsWithSearch.links.href,
        "",
        true
      ));
    }
  
    if (
      download &&
        download.status.ended &&
        download.content
    ) {
      startDownloadData(download);
      dispatch(resetDownloadDocument());
    }
    let ragioneSociale =
        company && company.companies
          ? company.companies.find(el => {
            return el.codiceFiscale === companySelected;
          }).ragioneSociale
          : null;
    localStorage.setItem("ragsoc", ragioneSociale);  

  }, [documentsWithSearch.links, documentsWithSearch.results.list, currentIndex, 
    documentsWithSearch.isGettingDocumentsWithSearch, company.companies, download.status.ended, 
    download, download.content, detailsDocument.isDocRemoved.success, detailsDocument.info.status.error, 
    detailsDocument.info.errorCode]);
  
  useEffect(() => {
    if (!idByUrl) return;
    const newIdByUrl= location.pathname.split("dettaglio-documento/")[1];
    if (myType !== "STUDIO") {
      dispatch(updateReadCustomer(newIdByUrl));
    }
    getDetailDocument(newIdByUrl);
    setIdByUrl(newIdByUrl);
      
  }, [location.pathname]);

  const changeCurrentTab = (nTab) => {
    setCurrentTab(nTab);   
  };

  const renderVisibility = () =>  {
    
    if (myType !== "STUDIO" || detailsDocument.info.details.einvoice) {
      return null;
    }

    if (detailsDocument.info.details.visibleByStudioOnly) {
      return (
        <div
          className="gs-documents-detail-visible-change"
          style={{
            cursor: "pointer"
          }}
          onClick={e => {
            dispatch(setDocumentVisibility(
              auth,
              accountantSelected,
              accountantIdSelected,
              companySelected,
              clientIdSelected,
              detailsDocument.info.details.documentId,
              true
            ));
          }}
        >
          <FontAwesomeIcon
            icon={["far", "minus-hexagon"]}
            style={{ fontSize: "14px", color: "#d82829" }}
          />{" "}
          <FormattedMessage id="documents.detail.visibleByStudioOnly" />
        </div>
      );
    } 
    return (
      <div
        className="gs-documents-detail-visible-change"
        style={{
          cursor: "pointer"
        }}
        onClick={e => {
          dispatch(setDocumentVisibility(
            auth,
            accountantSelected,
            accountantIdSelected,
            companySelected,
            clientIdSelected,
            detailsDocument.info.details.documentId,
            false
          ));
        }}
      >
        <FontAwesomeIcon
          icon={["far", "check-square"]}
          style={{ fontSize: "14px", color: "#0090d1" }}
        />{" "}
        <FormattedMessage id="documents.detail.visibleByAll" />
      </div>
    );
    
  };

  const changeDocument = (documentId) => {
    navigate("/dettaglio-documento/" + documentId);   
  };

  const changeIndexDoc = (index) => {    
    dispatch(clearContent());
    setCurrentIndex(index);   
  };

  const onTableSelect= (selected) => {
    setFoldersSelected([...selected]);    
  };

  const onAddDocumentToFolders= () => {         
    let nomiFolders = [];
    if (folders) {
      for (let count = 0; count < folders.length; count++) {
        if (foldersSelected.includes(folders[count].id)) {
          nomiFolders.push(folders[count].folderName);
        }
      }
    }
    let doc = location.pathname.split("dettaglio-documento/")[1];
    let requestBody = {
      documentId: doc,
      foldersIds: foldersSelected
    };
    dispatch(updateDocsFolder(
      auth,
      accountantSelected,
      accountantIdSelected,
      companySelected,
      clientIdSelected,
      nomiFolders,
      requestBody
    ));
    setModalFoldervisible(false);
    setFoldersSelected([]);
  };

  const renderLink = () => {    
    let arrayLink = [];
    if (detailsDocument.info.details.linkedDocuments) {
      detailsDocument.info.details.linkedDocuments.map(el =>
        arrayLink.push(<div key={"link_" + el.documentId}>
          <FontAwesomeIcon
            icon={["far", "link"]}
            style={{ fontSize: "14px", color: "#d82829" }}
          />
          <FormattedMessage id="documents.linkedTo" />:{" "}
          <Link to={"/dettaglio-documento/" + el.documentId}></Link>
          <button
            className="linkButton"
            onClick={e => {
              e.preventDefault();
              changeDocument(el.documentId);
            }}
          >
            {el.fileName}
          </button>{" "}
            del {el.documentDate} in {el.macroCategory} / {el.documentType}
        </div>));

      return <div>{arrayLink}</div>;
    } 
    return null;
    
  };

  // Se l'utente cambia azienda, anche se ha i permessi sul documento,
  // deve essere reindirizzato alla lista documenti perchè lo stesso documento non appartiene anche
  // all'altra azienda
  let ragioneSociale =
      company && company.companies
        ? company.companies.find(el => {
          return el.codiceFiscale === companySelected;
        }).ragioneSociale
        : null;
    /*
    !!! ATTENZIONE Questa soluzione non va bene per la persona fisica. Va fatto il fix lato BE per restituire un
        errore
        if (localStorage.getItem("ragsoc") && localStorage.getItem("ragsoc") !== ragioneSociale) {
      navigate("/documenti");
    }
*/
  let typeDoc =  detailsDocument?.info && detailsDocument.info.details
    ? detailsDocument.info.details.standardTags.find(el => {
      return el.key === "category";
    }).value
    : null; 

  let modalTitle = `${intl.formatMessage({id: "actions.add"})} ${typeDoc} ${intl.formatMessage({id: "documents.detail.toFolder"})}`;

  const columns = [
    {
      title: "",
      dataKey: "folderName",
      style: { width: "40%" }
    },
    {
      title: "Tipo",
      dataKey: "folderType",
      style: { width: "25%" }
    },
    {
      title: "Periodo di riferimento",
      dataKey: "period",
      style: { width: "25%" }
    }
  ];

  let folderList = [];
  
  if (folders) {
    for (let count = 0; count < folders.length; count++) {
      folderList.push({
        id: folders[count].id,
        folderName: folders[count].folderName,
        folderType: folders[count].folderCategory
          ? categoryToDesc[folders[count].folderCategory]
            ? categoryToDesc[folders[count].folderCategory]
            : "Personalizzato"
          : "Personalizzato",
        period: folders[count].refYear ? folders[count].refYear : null
      });
    }
  }
  let splitSubtitle =
  detailsDocument?.info && detailsDocument.info?.details && detailsDocument.info.details?.documentId
    ? localStorage.getItem("subtitle-" + detailsDocument.info.details.documentId)
    : "";
  
  return (
    <Page
      pageRef={pageRef}
      activePage="/documenti"
      className="contentStructure transparent"
      subClassName="pageCss"        
      isPremiumAdvice={myType === "STUDIO"}
      servicesAgyo={servicesAgyo}
      marginZero={true}
      title={
        <div
          className="titleDocumentCard"
          style={{
            margin: "8px 16px",
            justifyContent: "center",
            display: "flex"
          }}
        >
          {typeDoc ? (
            <FontAwesomeIcon
              icon={["far", getIconByType(typeDoc, documentTypes)]}
              style={{
                color: "#005075",
                fontSize: "24px",
                marginRight: "10px",
                float: "left"
              }}
            />
          ) : null}
          <div style={{ lineHeight: "25px" }}>{splitSubtitle}</div>
        </div>
      }
      subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}
      backText={useIntl().formatMessage({id: "actions.goBack"})}
      backUrl={
        window.location.href.indexOf("from=dashboard") > -1
          ? "/"
          : window.location.href.indexOf("ask-answer=") > -1
            ? "/ask-answer/" + window.location.href.split("ask-answer=")[1]
            : "/documenti"
      }
    >
      <Modal
        visible={modalFoldervisible}
        title={modalTitle}
        onClose={() => {
          setModalFoldervisible(prev => !prev);
          setFoldersSelected([]);
          
        }}
        type="primary"
      >
        <div
          style={{
            fontSize: "16px",
            marginBottom: "30px",
            marginTop: "30px",
            width: "450px"
          }}
        >
          <FormattedMessage id="folders.selection" />
        </div>
        <div style={{width: "450px"}}>
          <Table
            columns={columns}
            dataSource={folderList}
            selection={true}            
            onSelect={(sel) => onTableSelect(sel)}
            selectedRows={
              foldersSelected && foldersSelected !== []
                ? foldersSelected
                : []
            } // lista di id selezionati
          />
        </div>
        <div style={{ marginTop: "30px", display: "flex", float: "right" }}>
          <div style={{ marginRight: "20px" }}>
            <Button
              kind="secondary"
              onClick={() => {
                setModalFoldervisible(prev => !prev);
                setFoldersSelected([]);               
              }}
            >
              <FormattedMessage id="actions.cancel" />
            </Button>
          </div>
          <div>
            <Button
              disabled={foldersSelected &&
                foldersSelected.length > 0
                ? false
                : true}
              onClick={onAddDocumentToFolders}
            >
              <FormattedMessage id="actions.add" />
            </Button>
          </div>
        </div>
      </Modal>
      <DownloadProgress downloadState={download} />

      {detailsDocument.info.status.started ? (
        <div style={{ textAlign: "center", height: "100vh" }}>
          <Spin
            indicator={
              <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
            }
            size="large"
            tip={
              <span>
                <FormattedMessage id="generic.loadingMessage" />
              </span>
            }
            style={{ fontSize: "20px", marginTop: "200px" }}
          />
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="anteprimaDocumento" style={{ flex: "1 0 auto" }}>
            <div className="leftColumn">
              <TabDetails
                changeCurrentTab={changeCurrentTab}
                currentTab={currentTab}
              />
              {currentTab === 1 ? (
                <Details />
              ) : (
                <div style={{ paddingTop: "24px" }}>
                  <Note
                    accountantSelected={accountantSelected}
                    accountantIdSelected={accountantIdSelected}
                    companySelected={companySelected}
                    clientIdSelected={clientIdSelected}
                    myType={myType}
                  />
                </div>
              )}
            </div>
            <div className="rightColumn">
              <div>{detailsDocument.info.details ? renderVisibility() : null}</div>
              <div>{detailsDocument.info.details ? renderLink() : null}</div>
              {detailsDocument.info.details ? (
                <Preview
                  accountantSelected={accountantSelected}
                  accountantIdSelected={accountantIdSelected}
                  companySelected={companySelected}
                  clientIdSelected={clientIdSelected}
                  myType={myType}
                  isEinvoice={detailsDocument.info.details && detailsDocument.info.details.einvoice}
                  documentId={idByUrl}
                  fileName={detailsDocument.info.details.fileName}
                  getDetailDocument={getDetailDocument}
                />
              ) : null}
            </div>
          </div>
          <div className="stickyFlex">
            <div>
              <DeleteButton
                accountantSelected={accountantSelected}
                accountantIdSelected={accountantIdSelected}
                companySelected={companySelected}
                clientIdSelected={clientIdSelected}                  
                myType={myType}
              />
              {myType === "STUDIO" &&
                detailsDocument.info.details &&
                !detailsDocument.info.details.einvoice ? (
                  <div
                    style={{
                      cursor: "pointer",
                      display: "inline-block",
                      paddingRight: "10px",
                      marginRight: "40px"
                    }}
                    onClick={() => {
                      navigate("/cambio-classificazione/" + detailsDocument.info.details.documentId);
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["far", "exchange"]}
                      style={{ color: "#0090d1", fontSize: "16px" }}
                    />
                    <span style={{ marginLeft: "8px" }}>
                      {" "}
                      <FormattedMessage id="documents.detail.classificator" />{" "}
                    </span>
                  </div>
                ) : null}
              {myType === "STUDIO" &&
                detailsDocument.info.details &&
                !detailsDocument.info.details.visibleByStudioOnly &&
                !detailsDocument.info.details.einvoice &&
                folders &&
                folders.length > 0 ? (
                  <div
                    style={{
                      cursor: "pointer",
                      display: "inline-block",
                      paddingRight: "10px",
                      marginRight: "40px"
                    }}
                    onClick={() => {
                      setModalFoldervisible(true);
                      setFoldersSelected([]);
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["far", "folder-open"]}
                      style={{ color: "#0090d1", fontSize: "16px" }}
                    />
                    <span style={{ marginLeft: "8px" }}>
                      {" "}
                      <FormattedMessage id="documents.detail.folder" />{" "}
                    </span>
                  </div>
                ) : null}
            </div>
            <div>
              <ArrowsCursor
                changeIndexDoc={changeIndexDoc}
                currentIndex={currentIndex}                  
              />
            </div>
          </div>
        </div>
      )}
    </Page>
  );
};

export default DocumentDetail;